<template>
  <div class="d-flex justify-space-between align-start mb-10 page-break-avoid">
    <img alt="Logo" :src="logoPath" crossorigin="anonymous" width="56" />
    <div class="d-flex flex-column text-right">
      <div
        class="body3 text--semitransparent"
        data-testid="executive-summary-report-header-generated-on"
      >
        {{ $t("reports.executiveSummaryReport.generatedOn") }} {{ generatedOn }}
      </div>
      <div
        class="body3 text--semitransparent"
        data-testid="executive-summary-report-header-version"
      >
        {{ $t("reports.executiveSummaryReport.version") }} {{ version }}
      </div>
    </div>
  </div>
  <v-chip
    class="px-2 py-1 mb-3"
    label
    rounded="3"
    color="indigo-faint"
    variant="flat"
    density="compact"
    data-testid="executive-summary-report-header-workspace-chip"
  >
    <span class="coro-label text-uppercase">{{ workplace }}</span>
  </v-chip>
  <div class="mb-10 page-break-avoid">
    <div class="headline5 mb-1">
      {{ $t("reports.executiveSummaryReport.reportTitle") }}
    </div>
    <div class="body2" data-testid="executive-summary-report-header-date-range">
      {{ selectedDateRange }}
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import moment from "moment";

export default defineComponent({
  props: {
    workplace: {
      type: String,
      required: true,
    },
    logoPath: {
      type: String,
      required: true,
    },
    version: {
      type: String,
      required: true,
    },
    selectedDateRange: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const generatedOn = computed(() => moment(props.version, "YYYYMMDD_HHmmss").format("L LT"));

    return { generatedOn };
  },
});
</script>
